package link.erpango.quip.data.db.entities

import app.cash.sqldelight.async.coroutines.awaitAsList
import link.erpango.quip.db.QuipDb

class CatalogDAO(val db: QuipDb) : ICatalogTable {

    override suspend fun upsertBrand(id: Long, name: String, updatedAt: Long) {
        db.vehicleCatalogQueries.upsertBrand(id, name, updatedAt)
    }

    override suspend fun upsertModel(id: Long, brandId: Long, name: String, updatedAt: Long) {
        db.vehicleCatalogQueries.upsertModel(id, brandId, name, updatedAt)
    }

    override suspend fun selectAllBrandNames(): List<String> {
        return db.vehicleCatalogQueries.selectAllBrands().awaitAsList().map { it.name }
    }

    override suspend fun selectModelNamesByBrandName(brandName: String): List<String> {
        return db.vehicleCatalogQueries.selectModelsByBrandName(brandName).awaitAsList().map { it.name }
    }

    override suspend fun selectModelNamesGroupedByBrand(): Map<String, List<String>> {
        return db.vehicleCatalogQueries.selectAllModelsWithBrandName().awaitAsList()
            .groupBy(keySelector = { it.brand_name }, valueTransform = { it.model_name })
    }

    override suspend fun deleteAll() {
        db.vehicleCatalogQueries.deleteAllModels()
        db.vehicleCatalogQueries.deleteAllBrands()
    }
}
